import req from "../http";

const blacklist = {
  // 取得 黑名單詳細資料
  getBlacklistDetail(params) {
    return req("get", "/Report/Blacklist/Detail", params);
  },

  // 取得 黑名單錄圖表
  getBlacklistChart(params) {
    return req("get", "/Report/Blacklist/Chart", params);
  },

  // 下載 黑名單詳細資料
  downloadBlacklist(params) {
    return req("get", "/Report/Blacklist/DetailExport", params, { responseType: "blob" });
  }
};

export default blacklist;